import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';

export const FIELD_ADD_CATEGORY = gql`
  mutation FieldAddCategory($input: FieldEditCategoryInput!) {
    fieldAddCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const FIELD_REMOVE_CATEGORY = gql`
  mutation FieldRemoveCategory($input: FieldEditCategoryInput!) {
    fieldRemoveCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;
